import { memo } from "react";

import Badge from "@/common/Badge";
import { BodyMetricTypes, inputInfoByUnitType, UnitTypes } from "@/constants/bodyMetrics";
import useAnswers from "@/utils/useAnswers";

interface BadgeProps {
    inputType: BodyMetricTypes;
    onChange: (value: UnitTypes) => void;
}

export const Badges = memo<BadgeProps>(({ inputType, onChange }) => {
    const { answers, setAnswers } = useAnswers();
    const unitType = (answers.units as UnitTypes) || UnitTypes.Imperial;

    const setUnitsToAnswers = (changedUnitType: UnitTypes) => () => {
        setAnswers((ans) => ({ ...ans, units: changedUnitType }));
        onChange(changedUnitType);
    };

    if (inputType === BodyMetricTypes.AGE) return null;

    return (
        <div className="flex gap-2 justify-self-center">
            {Object.values(UnitTypes).map((type) => {
                const info = inputInfoByUnitType[type][inputType];

                return (
                    <Badge
                        key={type}
                        title={info?.dimension}
                        onClick={setUnitsToAnswers(type)}
                        isActive={unitType === type}
                    />
                );
            })}
        </div>
    );
});
